<template>
    <div>
        
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'timers',
    data() {
        return {
            events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress'], 

            inactivityTimer: null,
            lastReadingsTimer:null,
            validateUserTimer: null
        }
    },
    mounted() {
        this.setIntervals()
    },
    methods: {
        ...mapActions({
            checkLogin: 'user/checkLogin',
            getLastReadings: 'meters/lastReadings',
            logout: 'user/logout'
        }),
        resetInactivityTimer(){
            clearTimeout(this.inactivityTimer)
            this.setTimeouts()
        },
        setTimeouts(){
            this.inactivityTimer = setTimeout( async () => {
                const result = await this.logout()
                if(result.message === 'Sesión terminada')
                    this.$router.push({ name: 'Login' })
            }, 1000 * 60 * 30)
        },
        setIntervals(){
            this.getLastReadings()
            this.lastReadingsTimer = setInterval(this.getLastReadings , 1000 * 60 * 1)
            this.validateUserTimer = setInterval(this.checkLogin , 1000 * 60 * 5)
        }
    },
}
</script>